/* Serviços de autenticação */
/* Criado por Carlos Eduardo em 04/01/2019 */
/*Métodos para niveis de usuários adiconados por Leandro Paranhos 20/03/2019 */
import jwt_decode from 'jwt-decode';

export const TOKEN_KEY = "@timesheet-token"; // nome do token
export const ALTERNATE_TOKEN_KEY = "token"; // alternate token key used in the login component
export const LEVEL_USER = "@level-user";

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY) ||
    sessionStorage.getItem(TOKEN_KEY) ||
    localStorage.getItem(ALTERNATE_TOKEN_KEY) ||
    sessionStorage.getItem(ALTERNATE_TOKEN_KEY);
};

export const isAuthenticated = () => {
  try {
    const token = getToken();
    if (!token) return false;

    return token.split('.').length === 3;
  } catch (error) {
    console.error("Error checking authentication:", error.message);
    return false;
  }
};

export const getLevelUser = () => {
  try {
    if (!isAuthenticated()) return null;
    return localStorage.getItem(LEVEL_USER) || sessionStorage.getItem(LEVEL_USER);
  } catch (error) {
    console.warn("Error retrieving user level:", error.message);
    return null;
  }
};

export const login = (token, keep = false) => {
  try {
    if (!token || token.split('.').length !== 3) {
      console.error("Token inválido ou ausente");
      return false;
    }

    const decoded = jwt_decode(token);
    const now = Date.now() / 1000;

    if (decoded.exp && decoded.exp < now) {
      console.warn("Tentativa de login com token expirado.");
      return false;
    }

    if (keep) {
      localStorage.setItem(TOKEN_KEY, token);
      localStorage.setItem(ALTERNATE_TOKEN_KEY, token);
    } else {
      sessionStorage.setItem(TOKEN_KEY, token);
      sessionStorage.setItem(ALTERNATE_TOKEN_KEY, token);
    }

    if (decoded && decoded.level) {
      const storage = keep ? localStorage : sessionStorage;
      storage.setItem(LEVEL_USER, decoded.level);
    }

    window.location.reload();
    return true;
  } catch (error) {
    console.error("Tentativa de login falhou:", error.message);
    return false;
  }
};

export const logout = () => {
  try {
    localStorage.clear();
    sessionStorage.clear();

    document.cookie.split(";").forEach((cookie) => {
      document.cookie = cookie
        .replace(/^ +/, "")
        .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
    });

    window.location.href = "/login";
  } catch (error) {
    console.error("Erro ao fazer logout:", error.message);
    window.location.href = "/login";
  }
};
